import { FormControl,  Select, MenuItem } from '@mui/material'
import { Translate } from 'react-i18nify';

export const CountrySelector = ({countries, setCountry, country, fromSx }) => {
    let convertedCountries = [
        {code: "", value: "SelectCountry"}
    ];
    if(countries?.length > 0){
        countries.forEach((element) => {
            convertedCountries.push({code: element.code, value: "Country-" + element.code})
        });
    } 
    return (
        <FormControl sx={fromSx} >
        <Select
            required
            labelId="country"
            id="country"
            displayEmpty
            value={country}
            onChange={(event, value) => {
                setCountry(value.props.value)
            }}
        >
            {convertedCountries.map((country, index) => {
                return <MenuItem key={index} value={country.code}><Translate value={country.value} /></MenuItem>
            })}        
        </Select>
    </FormControl>

    )
}

export const LanguageSelector = ({languageCodes, setLanguage, language}) => {
    let convertedCountries = [
        {code: "", value: "SelectLanguage"}
    ];
    
    if(languageCodes.length > 0){
        languageCodes.forEach((languageCode) => {
            convertedCountries.push({code: languageCode, value: "Language-" + languageCode})
        });
    }

    return (
        <FormControl>
        <Select
            required
            labelId="language"
            id="language"
            displayEmpty
            value={languageCodes.includes(language) ? language : ""}
            onChange={(event, props) => {
                setLanguage(props.props.value);
            }}
        >
            {convertedCountries.map((country, index) => {
                return <MenuItem key={index} value={country.code}><Translate value={country.value} /></MenuItem>
            })}        
        </Select>
    </FormControl>
    )
}
